const getDomainConfig = () => {
  const hostname = window.location.hostname;
  
  // Domain 1 Configuration
  if (hostname.includes('xando.1isystems.net') || hostname.includes('localhost')) {
    return {
      apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://xando.1isystems.net',
      brandName: process.env.REACT_APP_BRAND_NAME || 'Xando Analytics',
      theme: {
        primary: '#1976d2',
        secondary: '#dc004e'
      },
      logo: process.env.REACT_APP_LOGO_URL || null,
      domainName: 'xando.1isystems.net'
    };
  }
  
  // Domain 2 Configuration - Add your second domain here
  if (hostname.includes('your-second-domain.com')) {
    return {
      apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.your-second-domain.com',
      brandName: process.env.REACT_APP_BRAND_NAME || 'Your Second Brand',
      theme: {
        primary: '#4caf50',
        secondary: '#ff9800'
      },
      logo: process.env.REACT_APP_LOGO_URL || null,
      domainName: 'your-second-domain.com'
    };
  }
  
  // Default Configuration
  return {
    apiUrl: process.env.REACT_APP_API_BASE_URL || 'https://xando.1isystems.net',
    brandName: process.env.REACT_APP_BRAND_NAME || 'Default Analytics',
    theme: {
      primary: '#1976d2',
      secondary: '#dc004e'
    },
    logo: process.env.REACT_APP_LOGO_URL || null,
    domainName: 'default'
  };
};

export default getDomainConfig();